import React, { Fragment } from "react";
import escapeHTML from "escape-html";
import { Text } from "slate";
import Image from "next/image";
import Link from "next/link";

export const serialize = (children) =>
	children.map((node, i) => {
		if (Text.isText(node)) {
			let text = (<span dangerouslySetInnerHTML={{ __html: escapeHTML(node.text) }} />);

			if (node.bold) {
				text = <strong key={i}>{text}</strong>;
			}

			if (node.break) {
				text = <br key={i} />;
			}

			if (node.code) {
				text = <code key={i}>{text}</code>;
			}

			if (node.italic) {
				text = <em key={i}>{text}</em>;
			}

			if (node.underline) {
				text = <u key={i}>{text}</u>;
			}

			if (node.text === "") {
				text = <br />;
			}
			return <Fragment key={i}>{text}</Fragment>;
		}

		if (!node) {
			return null;
		}

		switch (node.type) {
			case "h1":
				return (<h1 key={i} className="text-[14px] md:text-[16px] lg:text-[26px] font-normal leading-[24px] lg:leading-[36px] xl:leading-[36px]">{serialize(node.children)}</h1>);
			case "h2":
				return (<h2 key={i} className="text-[14px] md:text-[16px] lg:text-[26px] font-normal leading-[24px] lg:leading-[36px] xl:leading-[36px]"> {serialize(node.children)}</h2>);
			case "h3":
				return (<h3 key={i} className="text-[14px] md:text-[16px] lg:text-[26px] font-normal leading-[24px] lg:leading-[36px] xl:leading-[36px]"> {" "} {serialize(node.children)}</h3>);
			case "h4":
				return (<h4 key={i} className="text-[14px] md:text-[16px] lg:text-[26px] font-normal leading-[24px] lg:leading-[36px] xl:leading-[36px]"> {serialize(node.children)}</h4>);
			case "h5":
				return (<h5 key={i} className="text-[14px] md:text-[16px] lg:text-[26px] font-normal leading-[24px] lg:leading-[36px] xl:leading-[36px]">{serialize(node.children)}</h5>);
			case "h6":
				return (<h6 key={i} className="text-[14px] md:text-[16px] lg:text-[26px] font-normal leading-[24px] lg:leading-[36px] xl:leading-[36px]">{serialize(node.children)}</h6>);
			case "blockquote":
				return (<blockquote key={i}>{serialize(node.children)}</blockquote>);
			case "ul":
				return (<ul key={i} className="text-[14px] md:text-[16px] xl:text-[18px] font-normal flex flex-col gap-3 list-outside pl-4 list-disc leading-[22px] md:leading-[24px] lg:leading-[26px]"> {serialize(node.children)}</ul>);
			case "ol":
				return (<ol key={i} className="text-[14px] md:text-[16px] xl:text-[18px] font-normal flex flex-col gap-3 list-outside pl-4 list-disc leading-[22px] md:leading-[24px] lg:leading-[26px]">{serialize(node.children)}</ol>);
			case "li":
				return (<li key={i} className="text-[14px] md:text-[16px] xl:text-[18px] font-ligt text-gray">{serialize(node.children)}</li>);
			case "link":
				return (<Link href={escapeHTML(node.url)} key={i} target={node.newTab ? "_blank" : null}>{serialize(node.children)}</Link>);
			case "upload":
				return (<Image key={i} src={`${process.env.NEXT_PUBLIC_SERVER_URL}${node.value.url}`} alt={node.value?.alt || "Hindustan Power"} width={0} height={0} unoptimized />
				);
			default:
				return (<p key={i} className="font-normal text-[14px] md:text-[16px] xl:text-[18px] leading-[22px] md:leading-[24px] lg:leading-[26px]">{serialize(node.children)}</p>);
		}
	});
